import { css } from '@isceco/widget-library2/external/lit'

import { RadioGroup as BaseRadioGroup } from '@isceco/widget-library2/basic-elements/RadioGroup/RadioGroup.js'

class RadioGroupVertical extends BaseRadioGroup {
  static get styles() {
    return [
      super.styles,
      css`
        .radios {
          display: flex;
          flex-direction: column;
        }
        .radio {
          margin-right: 0;
        }
        :host {
          --radio-group-label-font-weight: normal;
        }

        .inline > .label-wrapper > label {
          font-weight: var(--radio-group-label-font-weight);
        }
      `
    ]
  }
}
customElements.define('isceco-radio-group-vertical', RadioGroupVertical)
